import { Container, Paper, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AuthContext from "../../hooks/authContext";
// import cmsAdminLogo from "../../assets/images/cmsAdminLogo.png";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: theme.spacing(6),
  },
  card: {
    maxWidth: 640,
    margin: "0 auto",
    padding: theme.spacing(4),
    borderRadius: 16,
    border: "1px solid #d6e7df",
    borderTop: "5px solid #078037",
    boxShadow: "0 12px 32px rgba(7, 128, 55, 0.08)",
    background: "linear-gradient(180deg, #ffffff 0%, #f7fbf8 100%)",
    textAlign: "center",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    padding: "6px 12px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "#078037",
    backgroundColor: "#eaf5ef",
  },
  title: {
    color: "#1f2a37",
    fontFamily: '"Raleway", "MarkOT", "Arial", sans-serif',
    fontSize: 30,
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    marginBottom: theme.spacing(1.5),
  },
  text: {
    color: "#52606d",
    fontFamily: '"Raleway", "MarkOT", "Arial", sans-serif',
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.75,
  },
  link: {
    color: "#0b6bcb",
    fontWeight: 700,
    textDecoration: "underline",
  },
}));

const Unauthorized = () => {
  const auth = useContext(AuthContext);
  const styles = useStyles();

  return <Container maxWidth="lg" className={styles.wrapper}>
    {/* <div className={` text-center logo w-100`}><img src={cmsAdminLogo} alt="CMS" /></div> */}
    <Paper elevation={0} className={styles.card}>
      <div className={styles.badge}>Access Status</div>
      {auth?.isLoading !== true && (
        <Typography variant="h5" className={styles.title}>
          You are not authorized to access this page.
        </Typography>
      )}
      {auth?.status !== true && (
        <Typography variant="body1" className={styles.text}>
          Please <a href="/login" className={styles.link} style={{ color: "#0b6bcb" }}>sign in</a> with an account that has access.
        </Typography>
      )}
    </Paper>
  </Container>
};

export default Unauthorized;
